import { useMemo } from 'react';
import { getGlobalDataStore } from '@/lib/mock-data/global-data-store';

/**
 * Hook to fetch promises for a specific customer
 * Filters all promises by customer ID
 */
export function useCustomerPromises(customerId: string | undefined) {
  const promises = useMemo(() => {
    if (!customerId) return [];
    
    const store = getGlobalDataStore();
    const allPromises = store.getAllPromises();
    
    // Filter promises by customer ID
    return allPromises.filter(p => p.customerId === customerId);
  }, [customerId]);
  
  return {
    promises,
    isLoading: false,
    error: null
  };
}
